import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

function RevenueWebsiteTableHeader({ className, dataSourceVisibility, onFilter, sortBy, type }) {
  const { t: translate } = useTranslation()
  const nameValue = type === 'group' ? REVENUE_SORT_COLUMNS.CHANNEL_STORE_NAME : REVENUE_SORT_COLUMNS.STORE_NAME

  return (
    <Box className={classNames('revenue-website-table-header', className)}>
      <Box className={classNames('row-wrapper flex-row', sortBy.order)}>
        <Box
          className={classNames('cell-title flex-row cursor-pointer', {
            'is-active': sortBy.value === nameValue,
          })}
          data-value={nameValue}
          onClick={onFilter}
        >
          <Box display="inline" className="category mobile-only" data-value={nameValue} onClick={onFilter} />

          <Box data-value={nameValue} onClick={onFilter}>
            {translate('revenue.website')}
          </Box>
        </Box>

        <Box
          className={classNames('cell-value cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN,
          })}
          data-value={REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN}
          onClick={onFilter}
        >
          <Box display="inline" data-value={REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN} onClick={onFilter}>
            {translate('revenue.revenue')}
          </Box>
        </Box>

        <Box
          className={classNames('cell-difference cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.DIFFERENCE,
          })}
          data-value={REVENUE_SORT_COLUMNS.DIFFERENCE}
          onClick={onFilter}
        >
          %
        </Box>

        <Box
          className={classNames('cell-contribution cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.CONTRIBUTION,
          })}
          data-value={REVENUE_SORT_COLUMNS.CONTRIBUTION}
          onClick={onFilter}
        >
          {translate('revenue.contribution')}
        </Box>

        {dataSourceVisibility && (
          <Box
            className={classNames('cell-data-source cursor-pointer', {
              'is-active': sortBy.value === REVENUE_SORT_COLUMNS.DATA_SOURCE,
            })}
            data-value={REVENUE_SORT_COLUMNS.DATA_SOURCE}
            onClick={onFilter}
          >
            <Box className="fm fm-database" onClick={onFilter} data-value={REVENUE_SORT_COLUMNS.DATA_SOURCE} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

RevenueWebsiteTableHeader.propTypes = {
  className: PropTypes.string,
  dataSourceVisibility: PropTypes.bool,
  onFilter: PropTypes.func,
  sortBy: PropTypes.object,
  type: PropTypes.string,
}

export default RevenueWebsiteTableHeader
